import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-update-caso-uso',
  templateUrl: './dialog-update-caso-uso.component.html',
  styleUrls: ['./dialog-update-caso-uso.component.css']
})
export class DialogUpdateCasoUsoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
